import { useModalContext } from 'utils/contexts/modal';
import { useEditorContext } from '../contexts/editor';

export const useInsertSnippet = () => {
  const { editor } = useEditorContext();
  const { hideModal } = useModalContext();

  return (slugText: string) => {
    if (editor) {
      editor.insertContent(slugText);
      hideModal();
    }
  };
};
